import { create } from "zustand";
import { devtools } from "zustand/middleware";

export enum HeaderType {
  STANDARD,
  QUICK_ORDER,
}

type StandardHeaderView = {
  type: HeaderType.STANDARD;
};

type QuickOrderHeaderView = {
  type: HeaderType.QUICK_ORDER;
  orderId: string;
};

type HeaderView = StandardHeaderView | QuickOrderHeaderView;

type State = {
  headerView: HeaderView;
};

type Action = {
  setType: (header: HeaderView) => void;
};

export const useHeaderView = create(
  devtools<State & Action>((set, get) => ({
    headerView: {
      type: HeaderType.STANDARD,
    },

    setType: (header: HeaderView) => set({ headerView: header }),
  }))
);
